import { IOWidget, Action, Pair, nothing } from "widgets-for-react";
import { ExtraImages } from "../../utils/extra_images.mod";
import { BlockData, CMSState } from "../../../cms/blocks/types.gen";
import { Block } from "../../../wordpress/types_and_parser/standard_blocks.gen";
import { MediaBlockProps, MediaBlockStyle, MediaBlock } from "./widgets/mediaBlock";
import { CustomBlock } from "../../../wordpress/types_and_parser/custom_blocks.mod";
import { QuoteBlock, QuoteBlockProps, QuoteBlockStyle } from "./widgets/quoteBlock";
import { HeaderBlockProps, HeaderBlockStyle, HeaderBlock } from "./widgets/headerBlock.mod";
import { PublicSite_CustomPageData } from "../../application.mod";
import { PublicSiteState } from "../../../public_site.main.mod";
import { ImageTextBlockProps, ImageTextBlockStyle, ImageTextBlock } from "./widgets/imageTextBlock.mod";
import { TextBlockProps, TextBlock, TextBlockStyle } from "./widgets/textBlock";
import { MoreStoriesBlock, MoreStoriesBlockProps, MoreStoriesBlockStyle } from "./widgets/moreStoriesBlock";



//add here your custom blocks definitions
export type headerBlockData = { kind: 'headerBlock'; value: Pair<HeaderBlockProps<ExtraImages>, HeaderBlockStyle> }
export type mediaBlockData = { kind: "mediaBlock"; value: Pair<MediaBlockProps<ExtraImages>, MediaBlockStyle> }
export type quoteBlockData<extra_images> = { kind: "customQuoteBlock"; value: Pair<QuoteBlockProps<extra_images>, QuoteBlockStyle> }
export type imageTextBlockData = { kind: 'imageTextBlock'; value: Pair<ImageTextBlockProps<ExtraImages>, ImageTextBlockStyle> }
export type textBlockData = { kind: 'textBlock'; value: Pair<TextBlockProps<CustomBlockData, ExtraImages>, TextBlockStyle> }
export type moreStoriesBlockData = { kind: 'moreStoriesBlock', value: Pair<MoreStoriesBlockProps, MoreStoriesBlockStyle> }


export type CustomBlockData =
    | headerBlockData
    | mediaBlockData
    | quoteBlockData<ExtraImages>
    | imageTextBlockData
    | textBlockData
    | moreStoriesBlockData


export function isCustomBlockData<s, i>(b: BlockData<s, i> | CustomBlockData): b is CustomBlockData {
    return b.kind == "headerBlock" ||
        b.kind == "mediaBlock" ||
        b.kind == "customQuoteBlock" ||
        b.kind == "imageTextBlock" ||
        b.kind == 'textBlock' ||
        b.kind == 'moreStoriesBlock'
}

export function isCustomBlock<s, i>(b: Block | CustomBlock): b is CustomBlock {
    return b.kind == "vidda/media" ||
        b.kind == "vidda/quote" ||
        b.kind == "vidda/header" ||
        b.kind == "vidda/image-text" ||
        b.kind == 'vidda/text' ||
        b.kind == 'vidda/more-stories'
}

export function renderCustomBlock(block: CustomBlockData, public_state: PublicSiteState, key?: string): IOWidget<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>, Action<CMSState<CustomBlockData, ExtraImages, PublicSite_CustomPageData>>> {
    return s0 => {
        if (block.kind == "headerBlock") {
            return HeaderBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "mediaBlock") {
            return MediaBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)
        }
        else if (block.kind == "customQuoteBlock") {
            return QuoteBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "imageTextBlock") {
            return ImageTextBlock<CustomBlockData, ExtraImages>(block.value.fst, { style: block.value.snd })(s0)(public_state)
        }
        else if (block.kind == "textBlock") {
            return TextBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)
        }
        else if (block.kind == "moreStoriesBlock") {
            return MoreStoriesBlock<CustomBlockData, ExtraImages>(block.value.fst)(s0)(public_state)
        }
        else {
            return nothing();
        }
    }
}
